import { ChangeEventHandler } from 'react';

import { InputBase } from '@mui/material';

export type TextAreaPopoutInputBaseProps = {
    inputBaseChangeHandler: ChangeEventHandler<HTMLInputElement>,
    inputBasePlaceholder?: string,
    value?: unknown,
};

export const TextAreaPopoutInputBase = ({
    inputBaseChangeHandler,
    inputBasePlaceholder,
    value,
}: TextAreaPopoutInputBaseProps) => {
    return (
        <InputBase
            sx={{
                paddingLeft: '15px',
                paddingRight: '15px'
            }}
            onChange={inputBaseChangeHandler}
            multiline={true}
            placeholder={inputBasePlaceholder}
            value={value}
        />
    );
};
